import React, { useCallback, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { userLogin } from './graphql';
import { rootStore, PERSIST_APP_STORE_KEY } from 'store';
import { LoginForm } from './login-form';
import { useHistory, useLocation } from 'react-router-dom';
import { useHandleError, usePersistentLog } from 'shared-pages/services';
import { useMultitenantAliases } from './useMultitenantAliases';
import { useUserPermissions } from 'shared-pages/hooks/user-permissions';
import { AppStore } from 'shared-pages/store/app-store';
import { isRebatteryLiion } from 'shared-pages/common/constants';
import { useDeclareCollectionpoint } from './user-collectionpoint';
import { Snowfall } from 'shared-pages/components';
import { ChristmasTree } from 'shared-pages/components/decorative/christmas-tree';
import { Button, Col } from 'react-bootstrap';
import { toastSuccess } from 'shared-pages/utils/toasts';
import { gitnum } from 'gitnum';

export const LoginPage = () => {
  const appStore = rootStore.appStore;
  /*-------------------- Body -----------------------------------------------*/
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>(null);
  const history = useHistory();
  const location = useLocation();
  //const { from } = location.state || { from: { pathname: '/' } };
  const state: any = location.state || { from: { pathname: '/' } };
  const from = state.from;
  const { handleGraphqlError } = useHandleError('LoginPage');
  const { logError, logInfo } = usePersistentLog('LoginPage');

  const { declareCollectionpoint } = useDeclareCollectionpoint();

  /* const multitenants = useMultitenantAliases();
  const showAliases = multitenants && multitenants?.recordCount > 1 ? true : false; */

  const { getUserUsrParamsValues } = useUserPermissions();

  const [platformClosed, setPlatformClosed] = useState(false);

  //console.log('[LoginPage] invoked from =', from);
  /*! -------------------- Handlers -------------------------------------------*/
  /**
   * * 1. ΠΑΤΗΘΗΚΕ ΤΟ SUBMIT -> ΕΚΤΕΛΩ ΤΟ QUERY (Callback)
   */
  const handleSubmit = useCallback(
    async (values, actions) => {
      actions.setSubmitting(false);
      setLoading(true);
      userLogin(client, values.name, values.password)
        .then(async (res) => {
          // Set User Permissions
          appStore.setUserParams(res.getUserUsrParamsValues);

          // Login
          appStore.login(values.name, res);

          // Persist Version to Database -----
          const msg = `web-app version: ${gitnum.version}`;
          console.log('AppVersion', msg);
          logInfo('AppVersion', msg);

          if (false && rootStore.appStore.isContributor) {
            setPlatformClosed(true);
            toastSuccess(
              'Η Πλατφόρμα θα παραμείνει κλειστεί για Εισφορές. Παρακαλώ δοκιμάστε ξανά σε λίγες μέρες.',
            );
            rootStore.appStore.logOut();
            return;
          }

          // --------------------------- -----
          // Ο Χρήστης του Σημείου πρέπει να δηλώσει τα στοιχεία του σημείου
          // έχει ενημερωθεί το appStore ????

          if (
            isRebatteryLiion &&
            appStore.isCollectionPoint &&
            (appStore.associatedId === 0 || appStore.associatedId === null)
          ) {
            const ret = await declareCollectionpoint({
              userId: appStore.userLogin.userId,
            });
            if (!ret) {
              localStorage.removeItem(PERSIST_APP_STORE_KEY);
              appStore.logOut();
              return;
            } else {
              // Ενημέρωσε Collection point (associatedId)
              handleSubmit(values, actions); // re invoke
            }
          }

          // --------------------------- -----
          setLoading(false);
          history.replace(from);
        })
        .catch((err) => {
          console.log('login', 'catch', err);
          handleGraphqlError('userLogin-get', err, 'Σφάλμα Εισόδου.');
          setError(err);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [client, from, handleGraphqlError, history, logInfo, setPlatformClosed],
  );

  /*-------------------- Render ---------------------------------------------*/

  return (
    <div
      id="login-page"
      className="d-flex align-items-center justify-content-center"
    >
      <Snowfall />
      <LoginForm
        onSubmit={handleSubmit}
        message={error}
        loading={loading}
        //showAliases={showAliases}
      />
      {false && !platformClosed && (
        <div className="alert alert-warning mt-3" role="alert">
          Η Πλατφόρμα θα παραμείνει <strong>κλειστή για Εισφορές</strong>. Παρακαλώ δοκιμάστε ξανά
          σε λίγες μέρες.
        </div>
      )}
    </div>
  );
};
